

<app-bread-crumb [items]="[{text:'tamanhos'}]" [sectionTitle]="'Lista de  Tamanhos'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-12">

      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-list'" [boxTitle]="'Tamanhos'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">

          <ng-button (click)="create()"
            [button]="{name:'novo tamanho', faIconClass:'fa fa-plus',color:'danger'}">
          </ng-button>

        </ng-container>

        <!-- box-content -->
        <ng-container class="ng-box-content">

          <!-- inicio da tabela -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let size of objects" ngChangeColorOnHover>
                <td>{{ size?.cody }}</td>
                <td>{{ size?.size }}</td>
                <td>{{ size?.description }}</td>
     
              <!-- controles -->
              <ng-actions-table-bar>

                <ng-button title="Editar" (click)="edit(size)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>

                <ng-button title="Excluir" (click)="delete(size)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>

              </ng-actions-table-bar>

            </tr>

          </ng-table>
          <!-- fim da tabela -->

          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

        </ng-container>
        <!-- fim do conteudo do box -->
      </ng-box>
      <!-- fim do box -->
    </div>
  </div>
</section>